import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Course from "../components/course"
import SEMESTERS from "../data/semesters"

export default class IndexPage extends React.Component {
  courses = this.props.data.allMarkdownRemark.edges
  render() {
    return (
      <Layout>
        <header>
          <h1>
            <span role="img" aria-label="Rocket emoji">
              🚀
            </span>{" "}
            MIT
          </h1>
        </header>
        <div className="divider" />
        {SEMESTERS.map(sem => (
          <div key={sem.key}>
            <h2>{sem.display}</h2>
            {this.courses
              .filter(course => course.node.frontmatter.semester === sem.key)
              .map(course => (
                <Course
                  key={course.node.id}
                  slug={course.node.fields.slug}
                  courseNumber={course.node.frontmatter.course_number}
                  courseName={course.node.frontmatter.course_name}
                  tags={course.node.frontmatter.tags}
                  wordCount={course.node.wordCount.words}
                />
              ))}
          </div>
        ))}

        <div className="divider" />
      </Layout>
    )
  }
}

export const query = graphql`
  query getCourses {
    allMarkdownRemark(filter: { fileAbsolutePath: { regex: "/index[.]/" } }) {
      edges {
        node {
          frontmatter {
            course_number
            course_name
            semester
            tags
          }
          fields {
            slug
          }
          id
          wordCount {
            words
          }
        }
      }
    }
  }
`
